var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0887 41.24C9.71875 41.24 0.46875 31.9899 0.46875 20.6199C0.46875 9.24987 9.71875 0 21.0887 0C32.4587 0 41.7087 9.24987 41.7087 20.6199C41.7087 31.9899 32.4587 41.24 21.0887 41.24ZM21.0887 0.909912C10.2187 0.909912 1.37878 9.74987 1.37878 20.6199C1.37878 31.4899 10.2187 40.3298 21.0887 40.3298C31.9587 40.3298 40.7987 31.4899 40.7987 20.6199C40.7987 9.74987 31.9587 0.909912 21.0887 0.909912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 18.7688L32.1591 10.0488H29.0591L22.6591 16.8989L17.759 10.0488H9.28906L17.8691 22.0288L9.28906 31.199H12.389L19.2091 23.8989L24.4291 31.199H32.899L23.9991 18.7688ZM13.649 12.2788H16.5991L28.5291 28.949H25.5791L13.649 12.2788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9f8768ff0c0c04fa522b8e9af0926e7f.svg";
export { ForwardRef as ReactComponent };